//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngCorporateInformation', srsngCorporateInformation);

    function srsngCorporateInformation($rootScope, Event) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/software-info/corporate-information/corporate-information.html',
            scope: {
            },
            controller: controller
        };

        function controller($scope) {
            // this is intentional override
        }

    }

})();

